import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faSyncAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons'



import { supabase } from '../../api'

export const BrandForm = ({ defaultBrand, handleSave, canDelete, handleDelete }) => {


    const [brand, setBrand] = useState(defaultBrand || {});
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const doSave = async () => {
        setSaving(true)

        const { data, error } = await supabase
            .from('brands')
            .upsert(brand)
            .select()
            .single()
        if (error) {
            console.error('error upserting', error)
        }

        setSaving(false)
        if (data) handleSave(data)
    }

    const doDelete = async () => {

        if (!canDelete) return

        setDeleting(true)

        const { error } = await supabase
            .from('brands')
            .delete()
            .match({ id: brand.id })

        if (error) {
            console.error(error)
            return
        }

        handleDelete(brand.id)

    }

    return (
        <>
            <table style={{ width: 500 }}>
                <tbody>
                    <tr>
                        <td>Name</td>
                        <td><input name='name' style={{ width: 280 }} placeholder='name' defaultValue={brand.name} onChange={e => setBrand({ ...brand, name: e.target.value })} /></td>
                    </tr>
                    <tr>
                        <td>Can override cost?</td>
                        <td><input type="checkbox" name='cost' defaultChecked={brand.can_override_cost} onChange={e => setBrand({ ...brand, can_override_cost: e.target.checked })} />
                        </td>
                    </tr>
                </tbody>
            </table>

            <div className='space-between'>

                {canDelete ? <button className='inv' onClick={doDelete}>
                    <FontAwesomeIcon spin={deleting} icon={deleting ? faSyncAlt : faTrashAlt} />&nbsp;
                    Delete
                </button> : <span></span>}


                <button className='clear' onClick={doSave}>
                    <FontAwesomeIcon spin={saving} icon={saving ? faSyncAlt : faSave} />&nbsp;
                    Save
                </button>
            </div>
        </>
    )
}

export default BrandForm;